import { makeAutoObservable } from "mobx";
import { getProfile } from "../utils/request";
import { create, persist } from 'mobx-persist'


// Todo 總數據源
class UserStore {
  profile = null
  loading = false

  constructor() {
    makeAutoObservable(this);
  }

  async refresh() {
    this.loading = true
    const profile = await getProfile()
    // const profile = {data:{}}
    this.loading = false
    console.log('profile', profile)
    this.profile = profile.data
    return profile
  }

  loadTodo(url) {
    fetch(url)
      .then((res) => res.json())
      .then((data) => (this.todos = data));
  }
}

const schema = {
  profile: true
}


const hydrate = create({
  storage: localStorage,   // or AsyncStorage in react-native.
  jsonify: true  // if you use AsyncStorage, here shoud be true
})

const userStore = persist(schema)(new UserStore())

hydrate('userStore', userStore).then(() => console.log('userStore has been hydrated'))

export default userStore;
